import compareStrings from './compareStrings';

export function compareLines(
  firstShortName: string,
  secondShortName: string,
): number {
  const firstNumeric = parseInt(firstShortName, 10);
  const secondNumeric = parseInt(secondShortName, 10);
  if (!Number.isNaN(firstNumeric) && Number.isNaN(secondNumeric)) {
    return -1;
  }

  if (Number.isNaN(firstNumeric) && !Number.isNaN(secondNumeric)) {
    return 1;
  }

  if (
    !Number.isNaN(firstNumeric) &&
    !Number.isNaN(secondNumeric) &&
    firstNumeric !== secondNumeric
  ) {
    return firstNumeric - secondNumeric;
  }

  return compareStrings(firstShortName, secondShortName);
}
